import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService, EventManager, AlertService } from 'ng-jhipster';
import { SchoolCalendar } from './school-calendar.model';
import { SchoolCalendarService, SchoolCalendarUtilService } from '.';
import { Subscription } from 'rxjs/Subscription';
import { UnavailableDate, UnavailableDateService } from '../unavailable-date';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { SchoolService } from '../school';
import { Principal } from '../../shared';

@Component({
    selector: 'jhi-school-calendar-detail',
    templateUrl: './school-calendar-detail.component.html'
})
export class SchoolCalendarDetailComponent extends AbstractDialogComponent implements OnInit, OnDestroy {

    schoolCalendar: SchoolCalendar;
    private subscription: any;
    private schoolCalendarSubscription: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private schoolCalendarService: SchoolCalendarService,
        protected schoolService: SchoolService,
        private route: ActivatedRoute,
        private eventManager: EventManager,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
        this.jhiLanguageService.setLocations(['schoolCalendar', 'unavailableDate']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
        this.registerChangeInSchoolCalendar();
    }

    load(id) {
        this.schoolCalendarService.find(id).subscribe(schoolCalendar => {
            this.schoolCalendar = schoolCalendar;
        });
    }

    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.schoolCalendarSubscription.unsubscribe();
    }

    registerChangeInSchoolCalendar() {
        this.schoolCalendarSubscription = this.eventManager
        .subscribe('schoolCalendarListModification', (response) => this.load(this.schoolCalendar.id));
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school-calendar/school-calendar-detail.component.ts